import { render } from "./StudentTabs.vue?vue&type=template&id=698b3870&ts=true"
import script from "./StudentTabs.vue?vue&type=script&lang=ts"
export * from "./StudentTabs.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__